// extracted by mini-css-extract-plugin
export default {"file":"file","clickable":"clickable","file_object":"file_object","img":"img","non_svg":"non_svg","notSupportedFile":"notSupportedFile"};